<template>
  <button
    type="button"
    class="flex w-full touch-manipulation items-center gap-3 text-sm font-semibold"
    :class="disabled ? 'text-gray-300' : 'text-black active:text-gray-600'"
  >
    <span
      class="flex h-8 w-8 items-center justify-center rounded-lg"
      :class="
        disabled ? 'bg-gray-150 text-gray-400' : 'bg-gray-150 text-gray-500'
      "
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"  viewBox="0 0 14 14" fill="none" class="stroke-current"><path stroke="currentStroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 1.667v10.666M12.334 7H1.667"/></svg>
    </span>
    <span>{{ t('child-select.add-child') }}</span>
  </button>
</template>

<script setup lang="ts">
  import { useChildSelectLocales } from '../locales';

  defineProps<{
    disabled?: boolean;
  }>();

  const { t } = useChildSelectLocales();
</script>
